import createLucideIcon from '../createLucideIcon';

const ArrowDownRightFromCircle = createLucideIcon('ArrowDownRightFromCircle', [
  ['polyline', { points: '22,16 22,22 16,22 ', key: '1b057k' }],
  ['line', { x1: '22', y1: '22', x2: '12', y2: '12', key: '1dgvvf' }],
  [
    'path',
    { d: 'M12,22C6.5,22,2,17.5,2,12S6.5,2,12,2s10,4.5,10,10', key: '1og81t' },
  ],
]);

export default ArrowDownRightFromCircle;
